import React from "react";

import { Box, Button, Typography } from "@braintrust/braintrust-ui-components";

import { useClearFilters } from "../../apps/listing/hooks/use-clear-filters";
import { useJobLocationContext } from "../../context";

type JobsEmptyStateProps = {
  title: string;
  description: string;
};

export const JobsEmptyState = ({ title, description }: JobsEmptyStateProps) => {
  const location = useJobLocationContext();
  const { clearFilters } = useClearFilters();
  return (
    <Box
      sx={{
        textAlign: "center",
        borderRadius: 2,
        py: { xs: 4, md: 8, lg: 10 },
        px: { xs: 2 },
      }}
    >
      <Box sx={{ maxWidth: 626, margin: "auto" }}>
        <img
          src={`${SETTINGS.STATIC_URL}jobs/jobs-empty-state.svg`}
          alt=""
          width="150"
          height="149"
        />
        <Typography component="p" variant="label" sx={{ mt: 2, mb: 2 }}>
          {title}
        </Typography>
        <Typography component="p" fontWeight={400} sx={{ mb: 2 }}>
          {description}
        </Typography>
        <Button
          size="x-small"
          variant="secondary"
          onClick={() => clearFilters(location)}
        >
          Clear all filters
        </Button>
      </Box>
    </Box>
  );
};
